if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name="id[]"]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }

      let closest_parent = this.closest('.product__info-container');
      let current_variant_id = this.form.querySelector('input[name="id[]"]').value;
      var this_count = 0;
      if (closest_parent) {

        //alphabet-charm code start
        let alphabet_input = closest_parent.querySelector('#alphabet-charm-text');
        let alphabet_variants = closest_parent.querySelector('#alphabet-charm-variants');
        if (alphabet_input && alphabet_variants) {
          let letters = alphabet_input.value
            .toUpperCase()
            .replace(/[^A-Z]/g, '')
            .split('');
          let letterCountMap = letters.reduce((acc, letter) => {
            acc[letter] = (acc[letter] || 0) + 1;
            return acc;
          }, {});

          Object.entries(letterCountMap).forEach(([letter, count]) => {
            let option = alphabet_variants.querySelector(
              `option[data-title="${letter}"]`
            );
            if (option && option.value) {
              formData.append(`items[${this_count}][id]`, Number(option.value));
              formData.append(`items[${this_count}][quantity]`, count);
              formData.append(`items[${this_count}][parent_id]`, current_variant_id);
              this_count += 1;
            }
          });
        }
        // alphabet charm code end
        // icon charm code start
        let icon_charm_inputs = closest_parent.querySelectorAll('#icon-charm-variants input[name="quantity"]');
        if(icon_charm_inputs){
          icon_charm_inputs.forEach(input => {
            if(input.value > 0) {
              formData.append(`items[${this_count}][id]`, Number(input.dataset.variantId));
              formData.append(`items[${this_count}][quantity]`, input.value);
              formData.append(`items[${this_count}][parent_id]`, current_variant_id);
              this_count += 1;
            }
          });
        }
        // icon charm code end
      }

      

      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {

            fetch(`${routes.cart_update_url}`, config)
            .then((response) => {
              return response.text();
            })
            .then((state) => {
                const parsedState = JSON.parse(state);
                this.updateItemsHtml(parsedState);
                document.getElementById("add-to-cart-message").innerHTML = '<p>Item added to bag!</p>';
                document.body.classList.add('testbody');
                document.getElementById("drawer-name").classList.add("is-active","is-visible");
                document.body.classList.add('has_drawer');
            }).catch((e) => {
              console.error(e);
            });           

            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
      
      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
      
       
   
      if (errorMessage) {

        this.errorMessage.textContent = errorMessage;
      }
    }
    
    updateItemsHtml(html) {    
      var mf = window.variantStrings.mf;
      var total = Shopify.formatMoney(html.items_subtotal_price, mf);
    
      var str = '';
    
      if ( html.item_count > 0 ) {
        document.getElementById("empty-cart-id").style.display = "none";
        html.items.forEach(function(item, index) {
          var v_title = item.variant_title;
          var prod_title = item.product_title;
          var prod_image = '<div class="card-img var_'+ item.id +'"><a href="'+ item.url +'"></a></div>';
          var final_price = item.final_line_price;
          var original_price = item.original_line_price;
          var discounted_price = item.discounted_price;
          var indexNumber = index + 1; 
  
          // build prod price.
          var prod_price = '';
          var original_price = item.original_line_price;
          if (original_price!=final_price) {
            prod_price += '<div><p>' + Shopify.formatMoney(discounted_price,mf) + '</p></div>';
          } else {
            prod_price += '<div><p>' + Shopify.formatMoney(original_price,mf) + '</p></div>';
          }
  
          // build variant.
          var dVariant = '<div class="card_price_wrrap"><dl>';
          if (!item.product_has_only_default_variant) {
              item.options_with_values.forEach(function(variant_item, index) {
                
                  dVariant += '<h4 class="product-option" key="vrnt-'+ index +'">';
                // dVariant += variant_item.name +' : ';
                  dVariant += variant_item.value;
                  dVariant += '</h4>';
                
            });        
          }
          if (item.properties["Letter Charms"]){
              dVariant += '<h4 class="product-option">Letter Charms: ';
              dVariant += item.properties["Letter Charms"];
              dVariant += '</h4>';
          }
         dVariant += '</dl>';
         dVariant += '<p class="card-item-qty ' + (item.handle === 'ossa-gift-card' ? 'gift-product' : '') + '">x '+ item.quantity +'</p>';
         dVariant += '</div>';
  
          // build quantity form.
          var decIcon = '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-minus" fill="none" viewBox="0 0 10 2"><path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor"></path></svg>';
          var incIcon = ' <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus" fill="none" viewBox="0 0 10 10"><path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor"></path></svg>';
          var qtyStr = '<div class="card_content_bottom btm-item-' + item.id + ' ' + (item.handle === 'ossa-gift-card' ? 'gift-product' : '') + '"><div class="quantity--container"><div class="quentity'+(item.handle == 'ballchain-with-charms-and-letters' ? ' hidden': '' )+'">';
          qtyStr += '<quantity-input class="quantity">';
          qtyStr += '<button class="quantity__button no-js-hidden" name="minus" type="button"><span class="visually-hidden">Decrease quantity for '+ item.title +'</span>'+ decIcon +'</button>';
          qtyStr += '<input class="quantity__input ossn-quantity__input" type="number" name="updates[]" value="'+ item.quantity +'" min="0" aria-label="Quantity for '+ item.title +'" id="Drawer-quantity-'+ indexNumber +'" data-index="'+ indexNumber +'">';
          qtyStr += '<button class="quantity__button no-js-hidden" name="plus" type="button"><span class="visually-hidden">Increase quantity for '+ item.title +'</span>'+ incIcon +'</button>';
          qtyStr += '</quantity-input>';
          qtyStr += '</div> </div><div class="cart_card_price"><p>'+prod_price+'</p></div></div>';
  
          var removeIcon = '<div class="remove_product_cart"><cart-remove-button id="CartDrawer-Remove-'+ indexNumber +'" data-index="'+ indexNumber +'">';
          removeIcon += '<button class="button button--tertiary" aria-label="Remove '+ item.title +'">';
          removeIcon += '<span class="remove--button--style"><svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><line x1="12.8028" y1="2.19682" x2="2.19617" y2="12.8034" stroke="#ED4A24"></line><line x1="2.1973" y1="2.19674" x2="12.8039" y2="12.8033" stroke="#ED4A24"></line></svg></span></button></cart-remove-button></div></div>';
  
          str += '<div id="CartDrawer-Item-'+ indexNumber + '" class="product-cart-list">';
          str += '<div class="card_details">';
          // str += '<div><p>'+ prod_title +'</p></div>';
          // str += prod_price;            
          str += '<div class="middle_content_card">' + prod_image;  
          str += '<div class="card-content"><div class="top_heading_card">';
          str += '<div><p>'+ prod_title +'</p></div></div>' + dVariant +'<div class="space_between_card"></div>'+ qtyStr + '</div>' + removeIcon +'</div>'; 
          str += '</div></div>';         
           $.get('/cart?view=alternat_cart', function(cart, textStatus) {  
          var cart_img = $(cart).find('.card-img.var_'+item.id).html();
             
          if($(cart).find('.grid_pre_order.product-cart-'+item.id).length > 0){
            var pre_order = $(cart).find('.grid_pre_order.product-cart-'+item.id).find('.pre_order_est_date').html();
            $('<p class="preorder_cart">PREORDER</p><p class="pre_order_est_date">'+pre_order+'</p>').insertBefore(".btm-item-"+item.id);
          }
          setTimeout(function(){
            $('.var_'+item.id).html(cart_img);
          },100)
          });
        });
        str += '<div class="related_wrraper_main"></div>';
        document.getElementById("drawer__wrapper").classList.remove("empty-cart");
        document.getElementById("empty-cart-id").style.display = "none";
        document.getElementById("CartDrawer-Checkout").disabled = false;
          // Update Free-Shipping Bar.
           $.get('/cart?view=alternat_cart', function(cart, textStatus) {
            var freeShip = $(cart).find('.free-shipping-notice').html();
            $('.free-shipping-notice').html(freeShip);
            var upsell = $(cart).find('.related_wrraper_main').html();
            $('body').find('.related_wrraper_main').html(upsell);
          });        
      } else {
        // show cart is empty
        // console.log('else');
        document.getElementById("empty-cart-id").style.display = "flex";
        var empty_image_url = document.getElementById("empty-cart-id").dataset.image;
        var emptyStr = '<div class="product-cart-list drawer__inner-empty">';
        emptyStr += '<div class="empty_cart">';
        emptyStr += '<h2 class="empty_text">Your cart is empty</h2>';
        emptyStr += '<a class="empty-cart-link"  href="/">Start Shopping</a><img src="'+ empty_image_url +'" alt="cart is empty">';
        emptyStr += '</div></div>';
        document.getElementById("empty-cart-id").innerHTML = emptyStr;
        document.getElementById("CartDrawer-Checkout").disabled = true;
        document.getElementById("drawer__wrapper").classList.add("empty-cart");

      }
      
      // update html
      document.getElementById("totals__subtotal-value").innerHTML = total;
      document.getElementById("cart-total").innerHTML = total;
      document.getElementById("bag-count").innerHTML = html.item_count;
      document.getElementById("bagCnt").innerHTML = html.item_count;
      document.getElementById("CartDrawer-CartItems").innerHTML = str;
    }
  });
}
